import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  //FOR RANDOM BACKGROUND COLORS
  randomBgColor() {
    let x = Math.floor(Math.random() * 256);
    let y = Math.floor(Math.random() * 256);
    let z = Math.floor(Math.random() * 256);
    let bgColor = "rgb(" + x + "," + y + "," + z + ")";
   
    return bgColor;
  }

  //FOR EDITOR DISPLAY
  callMceEditor(edId, classInstance, tinymce, isReadonly = 0) {

    let that = classInstance;
    setTimeout(() => {
      tinymce.baseURL = 'assets';
      tinymce.init({
        selector: 'textarea#' + edId,
        draggable_modal: true,
        height: 300,
        // base_url: '/tinymce',
        suffix: '.min',
        themes: "assets/themes/silver",
        // icons: "assets/icons/",
        // content_css: '//www.tiny.cloud/css/codepen.min.css',

        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount'
        ],
        toolbar: that.toolbarWithoutBlankButton,
        image_title: true,
        automatic_uploads: true,
        image_description: false,
        file_picker_types: 'file image media',
        // external_plugins: { tiny_mce_wiris: "https://www.wiris.net/demo/plugins/tiny_mce/plugin.js" }, 
        // toolbar1: "tiny_mce_wiris_formulaEditor, tiny_mce_wiris_formulaEditorChemistry",
        file_picker_callback: function (cb, value, meta) {

          let input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*');

          // Note: In modern browsers input[type="file"] is functional without 
          // even adding it to the DOM, but that might not be the case in some older
          // or quirky browsers like IE, so you might want to add it to the DOM
          // just in case, and visually hide it. And do not forget do remove it
          // once you do not need it anymore.

          input.onchange = function () {

            // var file = $event.path[0].files[0];
            let file = input.files[0];

            let reader: any = new FileReader();

            reader.onload = function () {

              // Note: Now we need to register the blob in TinyMCEs image blob
              // registry. In the next release this part hopefully won't be
              // necessary, as we are looking to handle it internally.
              let id = 'blobid' + (new Date()).getTime();
              let blobCache = tinymce.activeEditor.editorUpload.blobCache;
              let base64 = reader.result.split(',')[1];
              let blobInfo = blobCache.create(id, file, base64);

              blobCache.add(blobInfo);

              // call the callback and populate the Title field with the file name

              cb(reader.result, { title: file.name });
            };
            reader.readAsDataURL(file);
          };

          input.click();
        },
        images_upload_handler: function (blobInfo, success, failure, progress) {
          let xhr, formData;

          xhr = new XMLHttpRequest();

          xhr.withCredentials = false;
          xhr.open('POST', that.apiEndpoint + '/upload_course_resource');
          xhr.setRequestHeader('session-token', localStorage.getItem('token')); // manually set header

          xhr.upload.onprogress = function (e) {
            progress(e.loaded / e.total * 100);
          };

          xhr.onerror = function () {
            failure("Image upload failed due to a XHR Transport error. Code: " + xhr.status);
          };

          xhr.onload = function () {
            let json;

            if (xhr.status != 200) {
              failure('HTTP Error: ' + xhr.status);
              return;
            }
            json = JSON.parse(xhr.responseText);

            if (!json || typeof json.resource_id != 'string') {
              failure('Invalid JSON: ' + xhr.responseText);
              return;
            }

            success(json.s3_location);
            let fileObj: any = {};
            fileObj._id = json.resource_id,
              fileObj.type = "file"
            that.fileArr.push(fileObj);
          };

          formData = new FormData();
          formData.append('resource_content', blobInfo.blob(), blobInfo.filename());


          xhr.send(formData);
        },
        setup: function (editor) {
          // if (edId == 'fibtype') {
          if (that.insertBlankFlag) {
            editor.ui.registry.addButton('customBlankButton', {
              text: 'Add Blank',
            });
          }
        },
        readonly: isReadonly
      });

    }, 100)
  }

  /**
   * To check value is object not array
   * @param {misc} value - To get the any value
   * @return {boolean} True if object or False
   */
  isObjectNotArray(value: any) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
  }

  /**
   * To check error message received from api
   * @param {object} error - To get error object
   */
  checkApiError(error: any) {
    let apiErrMessage = '';
    if(error.error && error.error.organisations) {
      const errOrgData = error.error.organisations;
      for (let key of Object.keys(errOrgData)) {
        if(errOrgData[key]) {
          if(this.isObjectNotArray(errOrgData[key])) {
            for (let subkey of Object.keys(errOrgData[key])) {
              if(Array.isArray(errOrgData[key][subkey]) && errOrgData[key][subkey].length > 0) {
                apiErrMessage = errOrgData[key][subkey][0];
                break;
              }
            }
          }
          else if(Array.isArray(errOrgData[key]) && errOrgData[key].length > 0) {
            apiErrMessage = errOrgData[key][0];
          }
          break;
        }
      }
    }
    return apiErrMessage;
  }

  /**
   * To get formatted date by date object
   * @param {object} dateObj - To get date object
   * @param {number} timeline - To get timeline to add in date
   * @returns {string} formatted date string
   */
  getFormatedDateByDateObject(dateObj: Record<string, number>, timeline: number = 0) {
    const date = new Date(dateObj.year, dateObj.month - 1, dateObj.day);
    if(timeline) {
      date.setDate(date.getDate() + timeline);
    }
    const formattedDate = date.toLocaleString('en-US', { month: 'short' })+' '+date.getDate()+', '+date.getFullYear();
    return formattedDate;
  }

  /**
   * To validate multiple email addresses
   */
  multipleEmailValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;

    const emailList = control.value.split(',').map(email => email.trim());

    // Email must start with a lowercase letter (a-z) and must be in a valid format.
    const emailRegex = /^[a-z](?:(?:[^-$<>()[\]\\.,;:\s@"]+(?:\.[^-$<>()[\]\\.,;:\s@"]+)*)|(".+"))@(?:[a-zA-Z0-9]+\.)+[a-zA-Z]{2,}$/;

    const allValid = emailList.every(email => emailRegex.test(email));
    return allValid ? null : { invalidEmails: true };
  }

  /**
   * To get formatted date string by date object
   * @param {object} dateObj - To get date object
   * @returns {string} formatted date string
   */
  formatDateObjToStr(dateObj: Record<string, number>) {
    const yyyy = dateObj.year;
    const dd = String(dateObj.day).padStart(2, '0');
    const mm = String(dateObj.month).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  /**
   * To get formatted date string by date object
   * @param {string} dateStr - To get date string
   * @returns {object} formatted date object
   */
  parseStrToDateObj(dateStr: string) {
    const [year, month, day] = dateStr.split('-').map(Number);
    return {year, month, day};
  }

  /**
   * To get limit feature editor
   * @param edId - To get editor id
   * @param classInstance - To get class object
   * @param tinymce - To get tinymce instance
   * @param isReadonly - To get readonly value 0 or 1
   * @returns editor
   */
  callMiniMceEditor(edId: string, classInstance: any, tinymce: any, formEditorFieldCtrl: any = '', isReadonly: number = 0, timeoutMS: number = 0, addClasses=['disabled']): void {

    const that = classInstance;
    setTimeout(() => {
      tinymce.baseURL = 'assets';
      tinymce.init({
        selector: 'textarea#' + edId,
        plugins: 'lists',
        toolbar: 'bold italic bullist',
        menubar: false,
        branding: false,
        statusbar: false,
        height: 300,
        suffix: '.min',
        themes: 'silver',
        setup: function (editor: any) {
          if (that.insertBlankFlag) {
            editor.ui.registry.addButton('customBlankButton', {
              text: 'Add Blank',
            });
          }

          // Sync TinyMCE content to Angular form control
          editor.on('change keyup blur', function () {
            const content = editor.getContent({ format: 'text' }).trim();
            const control = formEditorFieldCtrl;
            if (control) {
              control.setValue(content);
              control.markAsTouched();
              control.markAsDirty();
              control.updateValueAndValidity();
            }
          });

          // disable editor if readonly
          editor.on('init', () => {
            if (isReadonly) {
              const editorContainer = editor.getContainer();
              editorContainer.classList.add(addClasses.join(','));
            }
          });
        },
        readonly: isReadonly
      });
    }, timeoutMS);
  }

  /**
   * To get locations
   * @returns locations
   */
  getLocations() {
    const locations = [
      "Bangalore", "Pune", "Hyderabad", "Chennai", "Mumbai", "Delhi", "Noida",
      "Gurugram", "Delhi-NCR", "Chandigarh", "Mohali", "Jaipur", "Kolkata",
      "Ahmedabad", "Kochi", "Bhopal", "Indore"
    ];
    return locations;
  }

  /**
   * To get work modes
   * @returns work modes
   */
  getWorkModes() {
    const workModes = ["Hybrid", "Remote", "On-site"];
    return workModes;
  }
}
